/**
 * Tanı kaydı (S09): yalnız adreste `?debug=1` varken tutulur. Oturum geri yükleme, yenileme ve başarısız isteklerin
 * sonucu (HTTP durumu, kod, tarayıcı bağlamı) yazılır; jeton, çerez ve kişisel veri yazılmaz. Kayıt sekmenin
 * depolamasında (sessionStorage) ve geliştirici konsolundadır. Oturum açma ekranında tanı satırı yoktur (08 §8.15).
 */
export interface DiagnosticsEntry {
  readonly at: string;
  readonly event: string;
  readonly detail: Readonly<Record<string, string | number | undefined>>;
}

export interface Diagnostics {
  readonly enabled: boolean;
  record(event: string, detail: Readonly<Record<string, string | number | undefined>>): void;
  entries(): readonly DiagnosticsEntry[];
}

export const DIAGNOSTICS_STORAGE_KEY = 'ticarishift.debug';

const CAPACITY = 50;

/** `?debug=1` adreste mi (açılışta bir kez okunur). */
export function isDebugRequested(search: string): boolean {
  return new URLSearchParams(search).get('debug') === '1';
}

export function createDiagnostics(
  enabled: boolean,
  options: { clock?: () => Date; storage?: Pick<Storage, 'getItem' | 'setItem'> | null; context?: string } = {},
): Diagnostics {
  const clock = options.clock ?? (() => new Date());
  const storage = options.storage === undefined ? safeSessionStorage() : options.storage;
  const items: DiagnosticsEntry[] = [];

  return {
    enabled,
    record(event, detail) {
      if (!enabled) {
        return;
      }

      const entry: DiagnosticsEntry = { at: clock().toISOString(), event, detail: { ...detail, ctx: options.context } };
      items.push(entry);
      if (items.length > CAPACITY) {
        items.shift();
      }

      try {
        storage?.setItem(DIAGNOSTICS_STORAGE_KEY, JSON.stringify(items));
      } catch {
        // Depolama kapalıysa kayıt yalnız bellektedir.
      }

      // Tanı kaydı yalnız ?debug=1 ile açıktır; geliştirici konsolunda görünmesi amaçtır.
      // oxlint-disable-next-line no-console
      console.info('[TicariShift]', event, entry.detail);
    },
    entries() {
      return [...items];
    },
  };
}

function safeSessionStorage(): Pick<Storage, 'getItem' | 'setItem'> | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}
